import _ from 'lodash';

class ArrayDifferResult {
    _added;
    _removed;
    _existsInBoth;

    constructor(added, removed, existsInBoth) {
        this._added = added;
        this._removed = removed;
        this._existsInBoth = existsInBoth;
    }

    get added() {
        return this._added;
    }

    get removed() {
        return this._removed;
    }

    get existsInBoth() {
        return this._existsInBoth;
    }

    get noChanges() {
        return _.isEmpty(this._added) && _.isEmpty(this._removed);
    }
}

export default class ArrayDiffer {
    /**
     * ArrayDiffer service returns a function that compares 2 arrays and
     * returns what has been added and what was been removed based on
     * a predicate function. See the spec for usage.
     */
    static findChanges(oldArray, newArray, predicateFunc): ArrayDifferResult {
        let added = [];
        let removed = [];
        let existsInBoth = [];

        // To preserve the old behaviour when we were using lodash:
        // lodash treats undefined arrays as an empty array
        if (!oldArray) {
            oldArray = [];
        }

        if (!newArray) {
            newArray = [];
        }

        oldArray.forEach((oldItem) => {
            let item1ExistsInArray = newArray.find((newItem) => {
                return predicateFunc(oldItem) === predicateFunc(newItem);
            });
            if (!item1ExistsInArray) {
                removed.push(oldItem);
            } else {
                existsInBoth.push(oldItem);
            }
        });
        newArray.forEach((newItem) => {
            let item2ExistsInArray = oldArray.find((oldItem) => {
                return predicateFunc(oldItem) === predicateFunc(newItem);
            });
            if (!item2ExistsInArray) {
                added.push(newItem);
            }
        });
        return new ArrayDifferResult(added, removed, existsInBoth);
    }

    /**
     * Find changes with a simple equality (===) check. Should be much
     * faster than using a predicate
     * @param oldArray
     * @param newArray
     * @returns {ArrayDifferResult}
     */
    static findEqualityChanges(oldArray, newArray): ArrayDifferResult {
        let added = [];
        let removed = [];
        let existsInBoth = [];

        oldArray.forEach((oldItem) => {
            let item1ExistsInArray = newArray.includes(oldItem);
            if (!item1ExistsInArray) {
                removed.push(oldItem);
            } else {
                existsInBoth.push(oldItem);
            }
        });
        newArray.forEach((newItem) => {
            let item2ExistsInArray = oldArray.includes(newItem);
            if (!item2ExistsInArray) {
                added.push(newItem);
            }
        });
        return new ArrayDifferResult(added, removed, existsInBoth);
    }
}
